enum Routes {
    Authorisation = '/remote',
    Section3Review = '/remote/section3/review',
    Section2UploadDocuments = '/remote/section2/upload-documents',
    Section2Documents = '/remote/section2/documents',
    Section2EmployeeInformation = '/remote/section2/employee',
    Section2CompleteI9 = '/remote/section2/completeI9',
    Section2ThankYou = '/remote/section2/thankyou'
}

export default Routes;



// WEBPACK FOOTER //
// ./src/models/routes.ts